import { AnswersAndQuestionFlow } from './AnswersAndQuestionFlow';

export class AssessmentQuestion {
  public questionId: string;
  public questionDescription: string;
  public answersAndQuestionFlow: AnswersAndQuestionFlow[];
  public isFirstQuestion: boolean = false;
  public isLastQuestion: boolean = false;
  public isCurrent: boolean = false;
  public answer: string;

  public constructor(
    questionId: string,
    questionDescription: string,
    answersAndQuestionFlow: AnswersAndQuestionFlow[],
    isFirstQuestion: boolean = false,
    isLastQuestion: boolean = false,
    isCurrent: boolean = false,
  ) {
    this.questionId = questionId;
    this.questionDescription = questionDescription;
    this.answersAndQuestionFlow = answersAndQuestionFlow;
    this.isFirstQuestion = isFirstQuestion;
    this.isLastQuestion = isLastQuestion;
    this.isCurrent = isCurrent;
  }

  public getPossibleAnswers(): string[] {
    return this.answersAndQuestionFlow.map((qf) => qf.answer);
  }
}
